import { Pipe, PipeTransform } from '@angular/core';

import { bgGradient } from './function/bg-gradient.function';

/* TODO move to uikit */
@Pipe({
    name: 'cmpsBgGradient',
})
export class BgGradientPipe implements PipeTransform {
    transform(
        color: string,
        lighten1?: number,
        lighten2?: number,
        angle?: number,
    ): string | null {
        return bgGradient({ color, lighten1, lighten2, angle });
    }
}
